import { render } from "./CopyToSlaveInterface.vue?vue&type=template&id=723b3ac8"
import script from "./CopyToSlaveInterface.vue?vue&type=script&lang=js"
export * from "./CopyToSlaveInterface.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__